import Link from 'next/link'

import type { FC, ReactNode } from 'react'

import { Container } from '@/components/generals/container'
import { Logo } from '@/components/generals/logo'
import { brand } from '@/constants/brand'
import { HUB_NAV } from '@/constants/hubs'
import { CONSENT_REOPEN_EVENT } from '@/constants/analytics'

export const Footer: FC = (): ReactNode => {
    return (
        <footer className='mt-24 border-t border-border bg-secondary/40'>
            <Container className='py-14'>
                <div className='grid gap-10 md:grid-cols-[1.6fr_1fr_1fr]'>
                    <div className='flex flex-col gap-4'>
                        <Link href='/' className='flex items-center gap-2 text-primary'>
                            <Logo width={28} height={28} />
                            <span className='font-heading text-lg font-semibold tracking-tight text-foreground'>
                                WellPath<span className='text-primary'> Fusion</span>
                            </span>
                        </Link>

                        <p className='max-w-xs text-sm leading-relaxed text-muted-foreground'>
                            {brand.tagline} Practical, evidence-aware guidance for the whole person.
                        </p>

                        <a
                            href={`mailto:${brand.email}`}
                            className='text-sm font-medium text-primary hover:underline'
                        >
                            {brand.email}
                        </a>
                    </div>

                    <div className='flex flex-col gap-3'>
                        <h3 className='text-xs font-semibold uppercase tracking-[0.14em] text-foreground'>
                            Topics
                        </h3>
                        {HUB_NAV.map((hub) => (
                            <Link
                                key={hub.slug}
                                href={`/${hub.slug}`}
                                className='text-sm text-muted-foreground transition-colors hover:text-foreground'
                            >
                                {hub.label}
                            </Link>
                        ))}
                    </div>

                    <div className='flex flex-col gap-3'>
                        <h3 className='text-xs font-semibold uppercase tracking-[0.14em] text-foreground'>
                            Publication
                        </h3>
                        <Link href='/' className='text-sm text-muted-foreground transition-colors hover:text-foreground'>
                            Home
                        </Link>
                        <Link href='/tools' className='text-sm text-muted-foreground transition-colors hover:text-foreground'>
                            Tools
                        </Link>
                        <Link href='/exercises' className='text-sm text-muted-foreground transition-colors hover:text-foreground'>
                            Exercise library
                        </Link>
                        <Link href='/about' className='text-sm text-muted-foreground transition-colors hover:text-foreground'>
                            About
                        </Link>
                        <Link href='/#subscribe' className='text-sm text-muted-foreground transition-colors hover:text-foreground'>
                            Newsletter
                        </Link>
                        <Link href='/privacy' className='text-sm text-muted-foreground transition-colors hover:text-foreground'>
                            Privacy Policy
                        </Link>
                        <button
                            type='button'
                            onClick={() => window.dispatchEvent(new Event(CONSENT_REOPEN_EVENT))}
                            className='text-left text-sm text-muted-foreground transition-colors hover:text-foreground'
                        >
                            Cookie settings
                        </button>
                    </div>
                </div>

                <div className='mt-12 flex flex-col gap-3 border-t border-border pt-6 text-xs text-muted-foreground sm:flex-row sm:items-center sm:justify-between'>
                    <p>© 2026 WellPath Fusion. All rights reserved.</p>
                    <p className='max-w-md sm:text-right'>
                        Editorial content for general information only, not a substitute for professional medical advice.
                    </p>
                </div>
            </Container>
        </footer>
    )
}
